import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Icon, Loading } from '@folio/stripes-components';

const STEPS = [
  { key: 'preparing',   labelId: 'ui-plugin-inventory-templates.catalogingAgent.step.preparing' },
  { key: 'extracting',  labelId: 'ui-plugin-inventory-templates.catalogingAgent.step.extracting' },
  { key: 'enriching',   labelId: 'ui-plugin-inventory-templates.catalogingAgent.step.enriching' },
  { key: 'validating',  labelId: 'ui-plugin-inventory-templates.catalogingAgent.step.validating' },
  { key: 'awaiting_review', labelId: 'ui-plugin-inventory-templates.catalogingAgent.step.awaitingReview' },
];

const STATUS_ORDER = ['preparing', 'extracting', 'enriching', 'validating', 'awaiting_review', 'ready_to_apply', 'applied_to_form', 'completed'];

const getStepStatus = (stepKey, currentStatus) => {
  if (currentStatus === 'failed') return 'failed';
  const stepIdx    = STATUS_ORDER.indexOf(stepKey);
  const currentIdx = STATUS_ORDER.indexOf(currentStatus);
  if (stepIdx < currentIdx)  return 'completed';
  if (stepIdx === currentIdx) return 'active';
  return 'pending';
};

const StepIcon = ({ stepStatus }) => {
  if (stepStatus === 'completed') return <Icon icon="check-circle" style={{ color: '#4CAF50' }} />;
  if (stepStatus === 'active')    return <Loading size="small" />;
  if (stepStatus === 'failed')    return <Icon icon="times-circle" style={{ color: '#F44336' }} />;
  return <Icon icon="circle" style={{ color: '#ccc' }} />;
};

StepIcon.propTypes = { stepStatus: PropTypes.string.isRequired };

const JobProgressTracker = ({ status, events, error }) => {
  if (!status || status === 'idle' || status === 'uploading') return null;

  return (
    <div style={{ padding: '12px 0' }}>
      {/* Steps */}
      <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
        {STEPS.map(step => {
          const stepStatus = getStepStatus(step.key, status);
          return (
            <div
              key={step.key}
              style={{
                display:    'flex',
                alignItems: 'center',
                gap:        '8px',
                opacity:    stepStatus === 'pending' ? 0.4 : 1,
              }}
            >
              <StepIcon stepStatus={stepStatus} />
              <span style={{ fontSize: '13px', fontWeight: stepStatus === 'active' ? 600 : 400 }}>
                <FormattedMessage id={step.labelId} defaultMessage={step.key} />
              </span>
            </div>
          );
        })}
      </div>

      {/* Error */}
      {error && (
        <div style={{ marginTop: '12px', padding: '8px', backgroundColor: '#FFEBEE', borderRadius: '4px', fontSize: '12px', color: '#C62828' }}>
          <Icon icon="times-circle" /> {error}
        </div>
      )}

      {/* Recent events */}
      {events.length > 0 && (
        <div style={{ marginTop: '12px', maxHeight: '80px', overflowY: 'auto' }}>
          {events.slice(-3).map((ev, i) => (
            <div key={i} style={{ fontSize: '11px', color: '#666', padding: '2px 0' }}>
              {ev.data?.message ?? ev.eventType}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

JobProgressTracker.propTypes = {
  status: PropTypes.string,
  events: PropTypes.array,
  error:  PropTypes.string,
};

JobProgressTracker.defaultProps = {
  events: [],
  error:  null,
};

export default JobProgressTracker;
